import breakpoints from './breakpoints';
import colors from './colors';
import shadows from './shadows';
import spacing from './spacing';
import useMediaQuery from './useMediaQuery';
import zIndex from './zIndex';

export default {
  breakpoints,
  colors,
  spacing,
  shadows,
  useMediaQuery,
  zIndex
};
